import { render, staticRenderFns } from "./FinanceKits.vue?vue&type=template&id=23186620&"
import script from "./FinanceKits.vue?vue&type=script&lang=js&"
export * from "./FinanceKits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports